export const TWO_FACTOR_OTP_PENDING_SESSION_KEY = 'auth2faOtpPending';

export type VerificationMethodModel = 'email' | 'sms' | 'both';

export interface LoginResponseData2faModel {
  requires_2fa: boolean;
  method_used: VerificationMethodModel;
  otp_sent: boolean;
  message: string;
  verification_method: VerificationMethodModel;
  verification_target: string;
  verification_response: VerificationMethodModel;
  otp_id: number;
  client_id: number;
  chosen_method: VerificationMethodModel;
  primary_method: VerificationMethodModel;
  available_methods: VerificationMethodModel[];
  user: {
    email: string;
    phone_number: string;
    ihela_code: number;
    full_name: string;
    username: string;
    temp_token: string;
    token_type: 'temporary' | string;
    expires_in: number;
  };
  otp_validated: boolean;
  requires_permanent_token: boolean;
}

export interface TwoFactorAuthVerifyBodyModel {
  otp_menu: string;
  otp_data: {
    code: string;
  };
}

export interface TwoFactorVerificationOtherMethodResponseModel {
  user: {
    response_code: string;
    response_data: {
      requires_verification: boolean;
      verification_method: VerificationMethodModel;
      verification_target: string;
      verification_response: VerificationMethodModel;
      otp_id: number;
      client_id: number;
      message: string;
      alternative_method_used: VerificationMethodModel;
      primary_method: VerificationMethodModel;
    };
    response_message: string;
    success: boolean;
  };
}

export interface Login2FASuccessVericationOPTModel {
  user: {
    response_code: string;
    response_data: {
      user: {
        email: string;
        phone_number: string;
        has_pin: boolean;
        ihela_code: number;
        full_name: string;
        username: string;
        token: string;
        device_data: unknown | null;
        fcm_data: unknown | null;
      };
      otp_validated: boolean;
    };
    response_message: string;
    success: boolean;
    otp_validated: boolean;
    message: string;
  };
}
